
    var riot = require('riot')
    riot.tag2('kf-confirm', '<kf-modal ref="modal" size="min" hide center> <div class="confirm-title">{parent.opts.confirmTitle}</div> <div style="text-align: right;"> <button class="pure-button pure-button-success" onclick="{parent.onSuccess}">はい</button> <button class="pure-button" onclick="{parent.close}">キャンセル</button> </div> </kf-modal>', 'kf-confirm .confirm-title,[data-is="kf-confirm"] .confirm-title{ font-size: 1.2rem } kf-confirm kf-modal,[data-is="kf-confirm"] kf-modal{ display: block; z-index: 9999; }', '', function(opts) {
    this.onSuccess = () => {
      this.opts.onsuccess && this.opts.onsuccess();
      this.trigger('success');
    }

    this.close = () => {
      this.opts.onclose && this.opts.onclose();
      this.trigger('close');
    };
});
    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('kf-confirm')
    }
  }
  